const CAPABILITY_LABELS: Record<string, string> = {
  view_audit: "View product audit log",
  view_requests: "View authorization requests",
  view_policies: "View policies",
  view_connectors: "View connector installations",
  view_api_keys_meta: "View API key metadata",
  view_secret_values: "Reveal secret values in the admin UI",
  approve_sandbox: "Approve sandbox requests",
  approve_production: "Approve production requests",
  mutate_members: "Invite members and change roles",
  mutate_workspace_security: "Change workspace security settings",
  mutate_policies_sandbox: "Edit sandbox policies",
  mutate_policies_production: "Edit production policies",
  mutate_api_keys_sandbox: "Create or revoke sandbox API keys",
  mutate_api_keys_production: "Create or revoke production API keys",
  mutate_connectors_sandbox: "Configure sandbox connectors",
  mutate_connectors_production: "Configure production connectors"
};

export const capabilityLabel = (key: string): string =>
  CAPABILITY_LABELS[key] ?? key.replaceAll("_", " ");

export const capabilityGroupOrder = ["view", "mutate", "approve", "manage"] as const;

export const sortCapabilityKeys = (keys: string[]): string[] => {
  return [...keys].sort((a, b) => {
    const ga = capabilityGroupOrder.findIndex((g) => a.startsWith(g));
    const gb = capabilityGroupOrder.findIndex((g) => b.startsWith(g));
    const oa = ga === -1 ? 99 : ga;
    const ob = gb === -1 ? 99 : gb;
    if (oa !== ob) {
      return oa - ob;
    }
    return a.localeCompare(b);
  });
};
